import { ApolloClient } from '@apollo/client';

export const clearFeedbackRecordsCache = (client: ApolloClient<unknown>) => {
  const cache = client.cache;
  cache.modify({
    id: cache.identify({
      __typename: 'Query',
    }),
    fields: {
      executeEQL: (existing) => {
        if (existing?.result?.__typename === 'GetRecordsResponse') {
          const toRemoveIds = existing?.result?.records?.map(
            ({ __ref }: { __ref: string }) => {
              return __ref;
            },
          );
          if (!toRemoveIds) {
            return existing;
          }
          toRemoveIds?.forEach((id: string) => {
            cache.evict({ id });
          });
          cache.gc();
          return {};
        }
        return existing;
      },
    },
  });
};
